/**
 * Утилиты разбора `Discrepancy.groupKey` (фича 024).
 *
 * Backend кодирует группу в формат `position|code:{code}` / `grand-total`.
 *
 * Sprint 3 / A4: legacy `aggregate-by-work-kind|{workKind}` удалён —
 * pipeline 026 их больше не генерирует. Любая историческая запись
 * попадает в `kind: "raw"` fallback.
 */

export type ParsedGroupKey =
	| { kind: "position"; code: string }
	| { kind: "grand-total" }
	| { kind: "raw"; value: string };

/** Разбирает `groupKey` на дискриминированную форму. */
export function parseGroupKey(groupKey: string): ParsedGroupKey {
	const positionMatch = groupKey.match(/^position\|code:(.+)$/);
	if (positionMatch) return { kind: "position", code: positionMatch[1] };
	if (groupKey === "grand-total") return { kind: "grand-total" };
	return { kind: "raw", value: groupKey };
}

/** Удобный shortcut: возвращает «4.5» для position, либо пустую строку для grand-total. */
export function extractCodeFromGroupKey(groupKey: string): string {
	const parsed = parseGroupKey(groupKey);
	if (parsed.kind === "position") return parsed.code;
	if (parsed.kind === "grand-total") return "";
	return parsed.value;
}
